import React from 'react'
import Tab from "components/tabs/tabs";
import { Outlet } from 'react-router-dom'
import Accounts from "assets/images/svg/accounts_settings_dark.svg";
import Info from "assets/images/svg/info_dark.svg";
import {useTranslation} from "react-i18next";

const AccountPage = () => {
  const {t} = useTranslation();

  return (
    <div className="settings myAccount">
    <div className="header">
            <h1 className='title'>{t('profile:account') as string}</h1>
    </div>
    <hr className="hr" />

      <div className="tabs">
        <div className="nav">
          <Tab url="profile-info" title={t('profile:profile-info')} img={Info} />
          <Tab url="account-settings" title={t('profile:account-settings')} img={Accounts} />
        </div>
      </div>

    <Outlet />
    </div>
  )
}

export default AccountPage